import axios from 'axios';

const API_URL = '/api/progress/';

// Get user progress for all courses
const getUserProgress = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL, config);
  return response.data;
};

// Get user progress for a specific course
const getCourseProgress = async (courseId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(`${API_URL}courses/${courseId}`, config);
  return response.data;
};

const progressService = {
  getUserProgress,
  getCourseProgress,
};

export default progressService;